import { WorkOrderAssetTreeType } from '@atom/types/work';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  workOrderAsset: WorkOrderAssetTreeType;
  elementGroupName: string;
}

const ElementGroupDetailsTable = ({
  workOrderAsset,
  elementGroupName,
}: Props) => {
  return (
    <>
      {workOrderAsset.elementGroups.map(
        elementGroup =>
          elementGroup.name === elementGroupName &&
          elementGroup.elements.map(element => (
            <table className={classes.collapseBorder}>
              <thead>
                <tr>
                  <th className={classes.textboxTableTitle} colSpan={2}>
                    {element.name}
                  </th>
                </tr>
              </thead>
              <tbody className={classes.content}>
                {element.attributeGroups.map(attributeGroup => {
                  const attributeGroupIds = attributeGroup.attributes;

                  return attributeGroupIds.map(key => (
                    <tr className={classes.textboxTableRow}>
                      <td className={classes.textboxTableRowTitle}>
                        {element.attributes[key].name}
                      </td>
                      <td className={classes.value}>
                        {attributeDisplayUtility.display(
                          element.attributes[key].value,
                          element.attributes[key].dataType,
                          element.attributes[key].unit,
                          !!element.attributes[key].changeId,
                          element.attributes[key].newValue,
                        )}
                      </td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          )),
      )}
    </>
  );
};

export default ElementGroupDetailsTable;
